export class DailyConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "timeOfDay",
            "baseName": "timeOfDay",
            "type": "TimeOfDay",
            "format": ""
        },
        {
            "name": "startWindowMinutes",
            "baseName": "startWindowMinutes",
            "type": "number",
            "format": "long"
        }
    ];
    static getAttributeTypeMap() {
        return DailyConfig.attributeTypeMap;
    }
    constructor() {
    }
}
